import React, { useEffect, useState } from 'react';
import Modal from "react-modal/lib/components/Modal";
import api from '../../../../servidor/api';
import moment from 'moment';
import './ModalAcompanhamentoVisita.css';
import ModalAcompanhamentoVisitaDetalheAtividade from './ModalAcompanhamentoVisitaDetalheAtividade';

function ModalAcompanhamnetoVisita(props) {
    const [tabDados, setTabDados] = useState([]);
    const [isMobile, setIsMobile] = useState(false);

    const [isOpenAtividade, setisOpenAtividade] = useState(false);
    const [atividadeSelecionada, setatividadeSelecionada] = useState({});

    function buscaAtividades() {
        const jsonReq = {
            id_grupo_empresa: Number(localStorage.getItem("id_grupo_empresa")),
            id_cliente: props.atvcliselecionado.id_cliente,
            id_atividade: props.atvcliselecionado.id_atividade,
            data1: moment(props.dataInicial).format("DD/MM/YYYY"),
            data2: moment(props.dataFinal).format("DD/MM/YYYY")
        };

        api.post('v1/promotor/atividadeporcliente', jsonReq)
            .then((resposta) => {
                setTabDados(resposta.data);             
            })
            .catch((err) => {
                console.log(err);
            });
    }

    useEffect(() => {
        buscaAtividades();
    }, [props.atvcliselecionado.id_atividade, props.atvcliselecionado.id_cliente]);

    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth <= 768);
        checkMobile();
        window.addEventListener("resize", checkMobile);
        return () => window.removeEventListener("resize", checkMobile);
    }, []);

    // Bloqueia scroll da tela mãe quando modal está aberto
    useEffect(() => {
        if (props.isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }

        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [props.isOpen]);

    // Agrupa tabDados por data formatada (DD/MM/YYYY) usando Map para manter a ordem original
    const groupedByDateMap = new Map();
    tabDados.forEach(item => {
        const date = moment(item.data).format("DD/MM/YYYY");
        if (!groupedByDateMap.has(date)) groupedByDateMap.set(date, []);
        groupedByDateMap.get(date).push(item);
    });

    const orderedDates = Array.from(groupedByDateMap.keys());    


    function abrirAtividade(item){           
        setatividadeSelecionada(item);
        setisOpenAtividade(true);        
    }

    function fechaAtividade(){
        setisOpenAtividade(false);
    }

    return (
        
        <Modal
            isOpen={props.isOpen}
            onRequestClose={props.onRequestClose}
            overlayClassName="full-modal-overlay"
            ariaHideApp={false}
            className="full-modal-content"
        >         

        <ModalAcompanhamentoVisitaDetalheAtividade
           isOpen={isOpenAtividade}
           onRequestClose={fechaAtividade}
           atividadeSelecionada={atividadeSelecionada}
        />

            <div className="visita-modal-content">
                <div className="bsmodal-header visita-modal-header">
                    <div>
                        <h3 className="modal-title bolt visita-modal-title">Lista de Atividades</h3>
                        <div className="visita-modal-subtitle">
                            Cliente: {props.atvcliselecionado.cliente}
                        </div>
                    </div>
                    <div className="visita-header-badge">
                        {orderedDates.length > 0 ? `${tabDados.length} registros` : "Sem registros"}
                    </div>
                </div>

                <div className="visita-resumo-strip">
                    <div className="visita-resumo-item">
                        <span className="visita-resumo-label">Cliente</span>
                        <strong className="visita-resumo-value">{props.atvcliselecionado.cliente}</strong>
                    </div>
                    <div className="visita-resumo-item">
                        <span className="visita-resumo-label">Período</span>
                        <strong className="visita-resumo-value">
                            {moment(props.dataInicial).format("DD/MM/YYYY")} a {moment(props.dataFinal).format("DD/MM/YYYY")}
                        </strong>
                    </div>
                    <div className="visita-resumo-item">
                        <span className="visita-resumo-label">Registros</span>
                        <strong className="visita-resumo-value">{tabDados.length}</strong>
                    </div>
                    <div className="visita-resumo-item">
                        <span className="visita-resumo-label">Dias</span>
                        <strong className="visita-resumo-value">{orderedDates.length}</strong>
                    </div>
                </div>

                <div className="visita-painel-modal">
                    <div className="visita-painel-header">
                        <i className="bi bi-card-list"></i>
                        <h4 className="visita-painel-titulo">Atividades</h4>
                        <span className="visita-painel-badge">{orderedDates.length} dias</span>
                    </div>

                    <div className="visita-painel-body-modal">
                    {isMobile ? (
                        <div className="visita-mobile-lista">
                            {orderedDates.length > 0 ? (
                                orderedDates.map(date => (
                                    <div key={date} className="visita-mobile-dia">
                                        <div className="timeline-date-separator">
                                            Atividades do dia {date}
                                        </div>

                                        {groupedByDateMap.get(date).map((item, index) => (
                                            <div onClick={() => abrirAtividade(item)} key={index} className="visita-mobile-card">
                                                <div className="visita-mobile-card-header">
                                                    <div>
                                                        <span className="visita-mobile-card-kicker">Visita {item.id_visita}</span>
                                                        <div className="visita-mobile-card-title">{item.atividade}</div>
                                                    </div>
                                                    <span className="visita-mobile-card-badge">{item.realizado ?? "-"}</span>
                                                </div>
                                                <div className="visita-mobile-card-body">
                                                    <div className="visita-mobile-card-grid">
                                                        <div>
                                                            <span className="visita-mobile-label">Promotor</span>
                                                            <span className="visita-mobile-value">{item.id_promotor} - {item.promotor}</span>
                                                        </div>
                                                        <div>
                                                            <span className="visita-mobile-label">Equipe</span>
                                                            <span className="visita-mobile-value">{item.equipe || "-"}</span>
                                                        </div>
                                                        <div>
                                                            <span className="visita-mobile-label">Qt. Pessoas</span>
                                                            <span className="visita-mobile-value">{item.qtpessoas || "-"}</span>
                                                        </div>
                                                        <div>
                                                            <span className="visita-mobile-label">Veterinário</span>
                                                            <span className="visita-mobile-value">{item.veterinario || "-"}</span>
                                                        </div>
                                                        <div>
                                                            <span className="visita-mobile-label">Venda</span>
                                                            <span className="visita-mobile-value">{item.houvevenda || "-"}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                ))
                            ) : (
                                <div className="visita-empty-state">Nenhum dado encontrado.</div>
                            )}
                        </div>
                    ) : (
                        <div className="visita-table-wrap">
                            <table className="table table-hover mb-0 visita-table">
                                <thead>
                                    <tr>
                                        <th>ID Visita</th>
                                        <th>Data</th>
                                        <th>Promotor</th>
                                        <th>Atividade</th>
                                        <th>Equipe</th>
                                        <th>Qt. Pessoas</th>
                                        <th>Veterinário</th>
                                        <th className="text-center">Venda</th>
                                        <th className="text-center">Realizada</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {tabDados.length > 0 ? (
                                        tabDados.map((item, index) => (
                                            <tr key={index} onClick={() => abrirAtividade(item)}>
                                                <td>{item.id_visita}</td>
                                                <td>{moment(item.data).format("DD/MM/YYYY")}</td>
                                                <td>{`${item.id_promotor} - ${item.promotor}`}</td>
                                                <td>{`${item.id_atividade} - ${item.atividade}`}</td>
                                                <td>{item.equipe || "-"}</td>
                                                <td className='text-center'>{item.qtpessoas || "-"}</td>
                                                <td>{item.veterinario || "-"}</td>
                                                <td className="text-center">{item.houvevenda || "-"}</td>
                                                <td className="text-center">{item.realizado || "-"}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="9" className="text-center">
                                                Nenhum dado encontrado.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    )}
                    </div>
                </div>

                <div className="bsmodal-footer visita-modal-footer" style={{ justifyContent: 'flex-start' }}>
                    <button
                        onClick={props.onRequestClose}
                        type="button"
                        className="btn btn-secondary px-4"
                    >
                        Voltar
                    </button>
                </div>
            </div>
        </Modal>
    );
}

export default ModalAcompanhamnetoVisita;
